import api from '@/api/axiosConfig.js';

function toApiError(error, fallback = 'No se pudo completar la operación.') {
  const message = error?.response?.data?.error || error?.message || fallback;
  const apiError = new Error(message);
  apiError.status = error?.response?.status;
  return apiError;
}

function unwrap(response, fallback) {
  if (!response?.data?.ok) {
    throw new Error(response?.data?.error || 'No se pudo completar la operación.');
  }
  return response.data.data ?? fallback;
}

export async function fetchPuntosVenta(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    params.set(key, value);
  });
  const query = params.toString();
  const response = await api.get(`/api/puntos-venta${query ? `?${query}` : ''}`);
  return unwrap(response, []);
}

export async function fetchPuntosVentaMeta() {
  const response = await api.get('/api/puntos-venta/meta');
  return unwrap(response, { sucursales: [] });
}

export async function createPuntoVenta(payload) {
  try {
    const response = await api.post('/api/puntos-venta', payload);
    return unwrap(response, null);
  } catch (error) {
    throw toApiError(error, 'No se pudo crear el punto de venta.');
  }
}

export async function updatePuntoVenta(id, payload) {
  const response = await api.put(`/api/puntos-venta/${id}`, payload);
  return unwrap(response, null);
}

export async function togglePuntoVenta(id, activo) {
  const response = await api.patch(`/api/puntos-venta/${id}/estado`, { activo });
  return unwrap(response, null);
}
